import axios, { AxiosResponse } from 'axios';
import axiosInstance from '../../../interceptors/axiosInstance';
import { RespuestaDesactivarMutuoDTO } from '../components/desactivarMutuo/desactivarMutuo';

export const desactivarMutuo = async (idMutuo: number): Promise<AxiosResponse> => {
    const axiosResponse: Promise<AxiosResponse> = axiosInstance.delete(
        `siscred-api-mutuo/v1/mutuo/desactivar-mutuo/${idMutuo}`
    );
    return axiosResponse;
};

export const desactivar = async (idMutuo: number): Promise<AxiosResponse<RespuestaDesactivarMutuoDTO>> => {
    const response: AxiosResponse<RespuestaDesactivarMutuoDTO> = await axiosInstance.get(
        `siscred-api-mutuo/v1/mutuo/validar-desactivar-mutuo`, 
        {
            params: { 
                idMutuo: idMutuo
            }
        }
    );
    return response;
};

